import { internal, template, AutoSizeTextarea } from '../../vendor/elix.js';

import FilledFloatingLabelInputLightMixin from '../mixins/filled-floating-label-input-light-mixin.js';
import EmptyValueMixin from '../mixins/empty-value-mixin.js';

class TpTextAreaFilledLight extends
  FilledFloatingLabelInputLightMixin(
  EmptyValueMixin(
    AutoSizeTextarea
  )) {

  get [internal.template]() {

    return template.concat(

      super[internal.template],

      template.html`

        <style>

          :host {
            display: block;
          }

          #inner {
            min-width: 170px;
          }

        </style>
      `
    );

  }

}

export default TpTextAreaFilledLight;


